import { ReactElement } from 'react'
import { Box, Dialog, Button } from '@machobear/design-system'

type ReactNodeNoStrings = ReactElement | boolean | null | undefined

type Props = {
  visible: boolean
  onClose: () => void
  title: string
  description: ReactNodeNoStrings
  illustration: ReactNodeNoStrings
  ctaText: string
  ctaAction: () => void
  hideXButton?: boolean
  cancelButton?: boolean
  cancelText?: string
}

const WarningModal = ({
  visible,
  onClose,
  title,
  description,
  illustration,
  ctaText,
  ctaAction,
  hideXButton,
  cancelButton,
  cancelText
}: Props) => {
  return (
    <Dialog
      id="warningDialog"
      open={visible}
      onClose={onClose}
      width="xsmall"
      title={title}
      description={description}
      illustration={illustration}
      hideXButton={hideXButton}
    >
      <Box display="flex" alignItems="center" gap="xsmall">
        {cancelButton && (
          <Button variant="transparent" onClick={onClose}>
            {cancelText}
          </Button>
        )}
        <Button variant="solid" onClick={ctaAction}>
          {ctaText}
        </Button>
      </Box>
    </Dialog>
  )
}

export default WarningModal
